<template>
  <base-material-card color="primary" icon="mdi-file-compare" inline class="px-5 py-5">
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">Adicionar Validação de Baixas</div>
    </template>

    <v-form class="pt-5">
      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field id="titulo-validacao-baixas" v-model="titulo" label="Título" outlined :error-messages="errors" />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row id="periodo-base-validacao-baixas" align="center" no-gutters class="mx-4">
        <v-col class="pb-0 pt-1" sm="5" cols="12">
          <v-menu
            v-model="menuPickerBaseInicio"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider v-slot="{ errors }" rules="required|min:10">
                <v-text-field
                  v-model="dataFormattedBaseInicio"
                  v-mask="'##/##/####'"
                  :error-messages="errors"
                  class="pt-0"
                  label="Data Base"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataBaseInicio = parseDate(dataFormattedBaseInicio)"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataBaseInicio"
              locale="pt-br"
              @input="
                menuPickerBaseInicio = false;
                dataFormattedBaseInicio = formatDate(dataBaseInicio);
              "
            />
          </v-menu>
        </v-col>
        <v-col class="py-4 text-center" style="white-space: nowrap !important" sm="1" cols="12">
          <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
        </v-col>
        <v-col class="pb-0 pt-1" sm="5" cols="12">
          <v-menu
            v-model="menuPickerBaseFim"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider v-slot="{ errors }" rules="required|min:10">
                <v-text-field
                  v-model="dataFormattedBaseFim"
                  v-mask="'##/##/####'"
                  :error-messages="errors"
                  class="pt-0"
                  label="Data Base"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataBaseFim = parseDate(dataFormattedBaseFim)"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataBaseFim"
              locale="pt-br"
              @input="
                menuPickerBaseFim = false;
                dataFormattedBaseFim = formatDate(dataBaseFim);
              "
            />
          </v-menu>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    name: 'ParametrosValidacaoBaixas',

    mixins: [dateFormatterMixins],

    data() {
      return {
        titulo: '',
        menuPickerBaseInicio: false,
        menuPickerBaseFim: false,
        dataFormattedBaseInicio: '',
        dataBaseInicio: '',
        dataFormattedBaseFim: '',
        dataBaseFim: ''
      };
    },

    methods: {
      exportData() {
        return {
          nome: this.titulo,
          data_base_inicio: this.dataBaseInicio,
          data_base_fim: this.dataBaseFim
        };
      }
    }
  };
</script>